module.exports = __webpack_public_path__ + "static/media/location-slash.7a3e69bd.svg";